import { render } from "./AppImg.vue?vue&type=template&id=07fc5422&scoped=true&ts=true"
import script from "./AppImg.vue?vue&type=script&lang=ts"
export * from "./AppImg.vue?vue&type=script&lang=ts"

import "./AppImg.vue?vue&type=style&index=0&id=07fc5422&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fc5422"]])

export default __exports__